import styleAf from "./Affiliate.module.scss";
import "./../../../index.scss";
import { toast } from "react-toastify";
import { ReactComponent as COPY } from '../../../assets/images/icon_copy.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useAppSelector } from "../../../services/hooks.service";
import { convertFeeToPrecent } from "../../../_utils";

export const CongratsModal = ({ link, onHide }) => {
  const { t } = useTranslation();
  const unlockUSDC = useAppSelector((state) => state.settings.affiliateDashboardThreshold);
  const feeShare = useAppSelector((state) => state.settings.affiliateDefaultFeeShare);

  return (
    <>
      <div className="modal_cont">
        { Number(unlockUSDC) > 0 && <p>{t("affiliates.reached_trading_volume", { vol: unlockUSDC })}</p> }
        { Number(feeShare) > 0 && <p>{t("affiliates.start_sharing_link", { fee: convertFeeToPrecent(feeShare) })}</p> }
      </div>
        <CopyToClipboard 
          text={link} 
          onCopy={() => toast.success(t("success_msg.success_msg"), {className: "custom-toast"})}
        >
          <div className={styleAf.link_cont}>
            <span className={styleAf.link_item_label}>{ t("affiliates.invite_link") }</span>
            <p>{link?.split("?r=")[1]}</p>
            <button><COPY /></button> 
          </div>
        </CopyToClipboard>
      <button 
        className={classNames(styleAf.transparent_btn, "transparent_btn")}
        onClick={onHide}
      >
        { t("comman_word.close") }
      </button>
    </>
  )
}
